module.exports = __webpack_public_path__ + "assets/img/house-8.82ff7b30.jpeg";